import { NegotiatedQuote } from '../../NegotiatedQuoteWidget.types';

export const getRowIdsWithComment = (items: NegotiatedQuote['lineItems'] | undefined) => {
  if (!items) return [];
  return items.filter((item) => item.supplierComment).map((item) => item.id);
};
